module.exports = __webpack_public_path__ + "static/media/size5.d8dea674.png";